
const calculate_wrapper = document.querySelectorAll('.calculator-wrapper');
if(calculate_wrapper.length > 0){
  calculate_wrapper.forEach(wrapper=>{
    const calculator_boxes = wrapper.querySelectorAll('.calculator-box');
    const calculate_buttons = wrapper.querySelectorAll('.calculate-btn');
    
    if(calculate_buttons.length > 0){
      calculate_buttons.forEach(calculate_button=>{
        if(calculate_button){
          calculate_button.addEventListener('click', function(){
            const selectedOption = Array.from(calculator_boxes).find(option=> option.classList.contains('is-active'));
            const hasSelectedOption = Boolean(selectedOption);

            const calculator_result = selectedOption.querySelector('.calculated_result');
            const weight_input = selectedOption.querySelector('.weight-input-field');
            const calculator_error_wrapper = selectedOption.querySelector('.error_validation_with_icon');
            if(weight_input.value !== '' && hasSelectedOption){
              const numericValue = Number(weight_input.value);
              const factor = Number(selectedOption.getAttribute('data-factor'));
              const formula_result = numericValue*factor*1000;
              const final_result = Math.round(formula_result);
              if(calculator_result){
                calculator_result.innerText = `${final_result} g`;
              }
            } else {
              const error_handling = calculator_error_wrapper.querySelector('.error_handling');
              if(calculator_result){
                calculator_result.innerText = '';
              }
              if(error_handling){
                let current_error_text = '';
                if(weight_input.value == '' && hasSelectedOption){
                  current_error_text = window.calculator_error_validation.error_with_weight;
                }
                error_handling.innerText = current_error_text;
                calculator_error_wrapper.style.display = "flex";
                setTimeout(() => {
                  calculator_error_wrapper.style.display = "none";
                  error_handling.innerText = '';
                }, 2500);
              }
            }
          })
        }
      })
    }    
  })
}

window.customSellingPlanDropdown = function(){
  const custom_dropdowns = document.querySelectorAll('.custom-dropdown');
  if(custom_dropdowns.length > 0){
    custom_dropdowns.forEach(dropdown=>{
      if (dropdown.dataset.sellingPlanInit === 'true') return;
      dropdown.dataset.sellingPlanInit = 'true';

      const selected = dropdown.querySelector(".dropdown-selected");
      const text = dropdown.querySelector(".dropdown-text");
      const optionsList = dropdown.querySelector(".dropdown-list.selling-plans-options");
  
      selected.addEventListener("click", function (e) {
        e.stopPropagation();
        dropdown.classList.toggle("open");
      });
  
      if (optionsList) {
        optionsList.addEventListener("click", function (e) {
          const option = e.target.closest(".selling-plans-option");
          if (!option) return;
          text.textContent = option.textContent;
          dropdown.classList.remove("open");
          const currentSelectedSellingPlanId = option.dataset.valueId;
          const closestProductContainer = dropdown.closest('.product__info-container');
          if (closestProductContainer) {
            const sellingPlanAppBlock = closestProductContainer.querySelector('.appstle_sub_widget');
            if (sellingPlanAppBlock) {
              let oneTimeInput = sellingPlanAppBlock.querySelector('.appstle_one_time_details_wrapper')?.querySelector('input');
              let sellingPlansInput = sellingPlanAppBlock.querySelector('.appstle_subscription_radio_wrapper')?.querySelector('input');
              if (option.dataset.valueId === '') {
                oneTimeInput.checked = true; 
              } else {
                sellingPlansInput.checked = true;
                const appBlockSelect = sellingPlanAppBlock.querySelector('.appstle_select');
                const appBlockSellingOption = appBlockSelect.querySelector(`option[value="${currentSelectedSellingPlanId}"]`);
                if (appBlockSellingOption) {
                  appBlockSelect.value = appBlockSellingOption.value;
                }
                const changeEvent = new CustomEvent('change', { bubbles: true });
                document.dispatchEvent(changeEvent, appBlockSelect);
                const inputRadio = sellingPlanAppBlock.querySelector(`.appstle_subscription_radio_wrapper input[type="radio"][name="selling_plan"]`);
                if (inputRadio) inputRadio.value = currentSelectedSellingPlanId;
              }
            }
            // PDP subscription discount display (match cart drawer)
            const priceWrapper = closestProductContainer.querySelector('.pdp-price-display-wrapper');
            if (priceWrapper) {
              const priceWeight = priceWrapper.querySelector('.price_weight');
              const subscriptionDiscount = priceWrapper.querySelector('.pdp-subscription-discount');
              const variantPriceEl = priceWrapper.querySelector('#variant-price');
              const variantSizeEl = priceWrapper.querySelector('#variant-size');
              if (currentSelectedSellingPlanId === '') {
                if (priceWeight) priceWeight.style.display = '';
                if (subscriptionDiscount) subscriptionDiscount.style.display = 'none';
              } else if (option.dataset.discountedFormatted) {
                if (priceWeight) priceWeight.style.display = 'none';
                if (subscriptionDiscount) {
                  const discountedEl = subscriptionDiscount.querySelector('.pdp-discounted-price');
                  const originalEl = subscriptionDiscount.querySelector('.pdp-original-price');
                  const saveLabelEl = subscriptionDiscount.querySelector('.pdp-save-label');
                  const unitEl = subscriptionDiscount.querySelector('.pdp-unit');
                  if (discountedEl) discountedEl.textContent = option.dataset.discountedFormatted;
                  if (originalEl && variantPriceEl) originalEl.textContent = variantPriceEl.textContent.trim();
                  if (saveLabelEl) saveLabelEl.textContent = option.dataset.saveLabel || '';
                  if (unitEl && variantSizeEl) unitEl.textContent = variantSizeEl.textContent.trim();
                  subscriptionDiscount.style.display = 'flex';
                }
              } else {
                if (priceWeight) priceWeight.style.display = '';
                if (subscriptionDiscount) subscriptionDiscount.style.display = 'none';
              }
            }
          }
        });
      }
  
      // Outside click close
      document.addEventListener("click", function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open");
        }
      });
    })
  }
}

/* price on variant change or refresh page */
function refreshPdpSubscriptionDiscountFromSelection() {
  const dropdown = document.querySelector('.product__info-container .custom-dropdown.custom-selling-plan-dropdown');
  if (!dropdown) return;
  const text = dropdown.querySelector('.dropdown-text');
  const optionsList = dropdown.querySelector('.dropdown-list.selling-plans-options');
  const priceWrapper = document.querySelector('.product__info-container .pdp-price-display-wrapper');
  if (!text || !optionsList || !priceWrapper) return;

  const currentSelection = (text.textContent || '').trim();
  const options = optionsList.querySelectorAll('.selling-plans-option');
  const matchingOption = Array.from(options).find(function (opt) {
    return (opt.textContent || '').trim() === currentSelection;
  });

  const priceWeight = priceWrapper.querySelector('.price_weight');
  const subscriptionDiscount = priceWrapper.querySelector('.pdp-subscription-discount');
  const variantPriceEl = priceWrapper.querySelector('#variant-price');
  const variantSizeEl = priceWrapper.querySelector('#variant-size');

  if (!matchingOption || matchingOption.dataset.valueId === '') {
    if (priceWeight) priceWeight.style.display = '';
    if (subscriptionDiscount) subscriptionDiscount.style.display = 'none';
    return;
  }

  if (matchingOption.dataset.discountedFormatted && subscriptionDiscount) {
    if (priceWeight) priceWeight.style.display = 'none';
    const discountedEl = subscriptionDiscount.querySelector('.pdp-discounted-price');
    const originalEl = subscriptionDiscount.querySelector('.pdp-original-price');
    const saveLabelEl = subscriptionDiscount.querySelector('.pdp-save-label');
    const unitEl = subscriptionDiscount.querySelector('.pdp-unit');
    if (discountedEl) discountedEl.textContent = matchingOption.dataset.discountedFormatted;
    if (originalEl && variantPriceEl) originalEl.textContent = variantPriceEl.textContent.trim();
    if (saveLabelEl) saveLabelEl.textContent = matchingOption.dataset.saveLabel || '';
    if (unitEl && variantSizeEl) unitEl.textContent = variantSizeEl.textContent.trim();
    subscriptionDiscount.style.display = 'flex';
  } else {
    if (priceWeight) priceWeight.style.display = '';
    if (subscriptionDiscount) subscriptionDiscount.style.display = 'none';
  }
}

window.customSellingPlanDropdown();

document.addEventListener('product-info:loaded', function () {
  window.customSellingPlanDropdown();
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
  subscribe(PUB_SUB_EVENTS.variantChange, function () {
    requestAnimationFrame(refreshPdpSubscriptionDiscountFromSelection);
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   const dropdown = document.querySelector(".custom-dropdown");
//   const selected = dropdown.querySelector(".dropdown-selected");
//   const text = dropdown.querySelector(".dropdown-text");
//   const options = dropdown.querySelectorAll(".dropdown-list li");

//   selected.addEventListener("click", function () {
//     dropdown.classList.toggle("open");
//   });

//   options.forEach(option => {
//     option.addEventListener("click", function () {
//       text.textContent = this.textContent;
//       dropdown.classList.remove("open");

//       // value access (select jaisa)
//       console.log("Selected value:", this.dataset.value);
//     });
//   });

//   // Outside click close
//   document.addEventListener("click", function (e) {
//     if (!dropdown.contains(e.target)) {
//       dropdown.classList.remove("open");
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.custom-sort-wrapper');
    const label = wrapper?.querySelector('.custom-sort-label');
    const activeText = wrapper?.querySelector('.active-sort-text');
    const dropdown = wrapper?.querySelector('.custom-sort-dropdown');
    const realSelect = wrapper?.querySelector('.hidden-sort-select');
    const items = wrapper?.querySelectorAll('.sort-item');

    // Set active text on load
    const selectedOption = realSelect?.options[realSelect.selectedIndex].text;
    if (activeText) {
      activeText.textContent = selectedOption;
    }

    // Toggle dropdown
    label?.addEventListener('click', () => {
      wrapper.classList.toggle('open');
    });

    // Click option
    items?.forEach((item) => {
      item.addEventListener('click', function () {
        const value = this.dataset.value;

        // update real select
        realSelect.value = value;
        // realSelect.dispatchEvent(new Event('change'));
        realSelect?.dispatchEvent(new Event('input', { bubbles: true }));
        realSelect?.dispatchEvent(new Event('change', { bubbles: true }));
        

        // update visible text
        activeText.textContent = this.textContent;

        // update active class
        items.forEach((i) => i.classList.remove('active'));
        this.classList.add('active');

        // close dropdown
        wrapper.classList.remove('open');
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!wrapper?.contains(e.target)) {
        wrapper?.classList.remove('open');
      }
    });
  });

  // document.addEventListener('DOMContentLoaded', function () {
  //   const priceEl = document.querySelector('.variant-price');
  //   const sizeEl = document.querySelector('.variant-size');

  //   const variantInputs = document.querySelectorAll('.input_pill_custom input[type="radio"]');

  //   variantInputs.forEach(input => {
  //     input.addEventListener('click', function() {
  //       // label ke span aur div se value fetch kar rahe hain
  //       const label = this.nextElementSibling; // input ke baad label
  //       const price = label.querySelector('span')?.textContent;
  //       const size = label.querySelector('.value')?.textContent;

  //       if (price) priceEl.textContent = price;
  //       if (size) sizeEl.textContent = size;
  //     });
  //   });
  // });
  